/**
 * 图片对比组件
 * @returns
 */

import React, { useRef, useEffect } from "react";
import { Content } from "@/types/content";
import { Box, Flex, Icon, Image } from "@chakra-ui/react";
import { RiExpandWidthFill } from "@remixicon/react";

type Props = {
  image: Content;
  compareImageSrc: string;
};

const ImageComparing = (props: Props) => {
  const wh = props.image.width - props.image.height;
  const rightImg = useRef<HTMLImageElement>(null);
  const rightImgBox = useRef<HTMLDivElement>(null);
  const leftImgBox = useRef<HTMLDivElement>(null);
  const leftImg = useRef<HTMLImageElement>(null);
  const moveBtn = useRef<HTMLDivElement>(null);
  const imgOuterBox = useRef<HTMLDivElement>(null);

  const handleResize = () => {
    const imgOuterBoxElement = imgOuterBox.current;
    const rightImgBoxElement = rightImgBox.current;
    // if (imgOuterBoxElement && rightImgBoxElement) {
    //   if (imgOuterBoxElement.offsetWidth > imgOuterBoxElement.offsetHeight) {
    //     rightImgBoxElement.style.width = `${imgOuterBoxElement.offsetHeight}px`;
    //     rightImgBoxElement.style.height = `${imgOuterBoxElement.offsetHeight}px`;
    //   } else {
    //     rightImgBoxElement.style.width = `${imgOuterBoxElement.offsetWidth}px`;
    //     rightImgBoxElement.style.height = `${imgOuterBoxElement.offsetWidth}px`;
    //   }
    // }
    console.log(imgOuterBoxElement?.offsetWidth,imgOuterBoxElement?.offsetHeight )
    if (imgOuterBoxElement && rightImgBoxElement) {
      if (
        props.image.width /imgOuterBoxElement.offsetWidth>
        props.image.height / imgOuterBoxElement.offsetHeight
      ) {
        rightImgBoxElement.style.width = `${
          imgOuterBoxElement.offsetWidth
        }px`;
        rightImgBoxElement.style.height = `${(props.image.height/props.image.width)*imgOuterBoxElement.offsetWidth}px`;
      } else {
        rightImgBoxElement.style.height = `${imgOuterBoxElement.offsetHeight}px`;
        rightImgBoxElement.style.width = `${(props.image.width/props.image.height)*imgOuterBoxElement.offsetHeight}px`;

      }
    }
  };

  useEffect(() => {
    handleResize();

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const trackLocation = () => {
    const rightImgElement = rightImg.current;
    const leftImgBoxElement = leftImgBox.current;
    const moveBtnElement = moveBtn.current;
    document.onmousemove = (e) => {
      // 禁止选中图片
      //  window.getSelection ? window.getSelection()?.removeAllRanges() : '';
      if (window.getSelection) {
        window.getSelection()?.removeAllRanges();
      }

      if (rightImgElement && leftImgBoxElement && moveBtnElement) {
        let rect: any = rightImgElement.getBoundingClientRect();
        let position =
          ((e.pageX - rect.left) / rightImgElement.offsetWidth) * 100;
        if (position <= 0) {
          position = 0;
        }
        if (position > 100) {
          position = 100;
        }
        moveBtnElement.style.left = position + "%";
        leftImgBoxElement.style.width = position + "%";
        // if (position>=0 && position<= 100) {
        //     moveBtnElement.style.left = position + "%";
        //     leftImgBoxElement.style.width = position + "%";
        // }
      }
    };
    document.onmouseup = () => {
      document.onmousemove = null;
      document.onmouseup = null;
    };
  };

  return (
    <Box
      // flexDirection={"column"}
      // justifyContent="center"
      // alignItems={"center"}
      // sx={{
      //   width: "full",
      //   height: "full",
      // }}
      w="100%"
      h="100%"
    >
      <Flex
        ref={imgOuterBox}
        w="100%"
        h="100%"
        margin={"0 auto"}
        justifyContent="center"
        alignItems={"center"}
      >
        <Box
          ref={rightImgBox}
          // justifyContent="center"
          // alignItems={"center"}
        >
          <Box
            position="relative"
            overflowX="visible"
            textAlign="center"
            // h={wh > 0 ? "auto" : "100%"}
            // w={wh > 0 ? "100%" : "auto"}
            w="100%"
            h="100%"
          >
            <Image
              // w={wh > 0 ? "100%" : "auto"}
              // h={wh > 0 ? "auto" : "100%"}
              w="100%"
              h="100%"
              ref={rightImg}
              src={props.compareImageSrc}
            />
            <Box
              ref={leftImgBox}
              width="50%"
              height="100%"
              position="absolute"
              top={0}
              left={0}
              overflowX="hidden"
              borderRight="2px solid #496AE1"
              boxSizing="border-box"
            >
              <Image
                ref={leftImg}
                src={props.image.image_url}
                float="left"
                height="100%"
                width="auto"
                maxWidth="none"
              />
            </Box>
            <Box
              ref={moveBtn}
              position="absolute"
              top="50%"
              left="50%"
              width="28px"
              height="28px"
              boxSizing="border-box"
              cursor="pointer"
              marginLeft="-14px"
              marginTop="-14px"
              p={0}
              color={"#496AE1"}
              onMouseDown={trackLocation}
              border="2px solid #496AE1"
            >
              <Icon as={RiExpandWidthFill} boxSize="24px" />
            </Box>
          </Box>
        </Box>
      </Flex>
    </Box>
  );
};

export default ImageComparing;
